export default __webpack_public_path__ + "static/media/Future Learn UX P2.1aa27543.webp";